import { render } from "./ApprovedDayIn.vue?vue&type=template&id=23ca34a0&scoped=true"
import script from "./ApprovedDayIn.vue?vue&type=script&lang=js"
export * from "./ApprovedDayIn.vue?vue&type=script&lang=js"

import "./ApprovedDayIn.vue?vue&type=style&index=0&id=23ca34a0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23ca34a0"]])

export default __exports__